import { Tabs } from 'antd';
import GeneralHeader from 'components/common/GeneralHeader';
import AbsenceTypesTab from 'components/tabs-components/absence_types';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
let accruing_conditions = [];
for (let i = 1; i <= 12; i++) {
  let date = new Date();
  date.setFullYear(2023, i - 1, 1);
  let daysInMonth = new Date(
    date.getFullYear(),
    date.getMonth() + 1,
    0,
  ).getDate();

  let item = {
    month: i,
    day: daysInMonth,
    balance: 0.0,
    reset_counter: false,
  };
  accruing_conditions.push(item);
}

const AbsenceTypeDetail = () => {
  const [activeTab, setActiveTab] = useState('1');
  const formik = useFormik({
    initialValues: {
      accruing_type: 'free',
      accruing_conditions: accruing_conditions,
      balance: -1,
      calendar_color: '',
      font_color: '',
      calendar_code: '',
      name: '',
      description: '',
      long_description: '',
      comment: '',
      french_description: '',
      french_long_description: '',
      french_comment: '',
    },
    // validationSchema: formSchema,
    onSubmit: (data) => {
      console.log('data', data);
    },
  });
  const location = useLocation();
  return (
    <div>
      <GeneralHeader
        pageTitle={location.state.item.name}
        icon="/icons/staff_leave_icon.svg"
        child={
          <div style={{ marginTop: '50px' }}>
            <Tabs
              style={{ marginTop: '100px' }}
              defaultActiveKey="1"
              activeKey={activeTab}
              onChange={(key) => {
                setActiveTab(key);
              }}
              items={[
                {
                  key: '1',
                  label: (
                    <div
                      style={{
                        color: activeTab === '1' ? '#0E3063' : '#757575',
                        fontSize: '20px',
                        margin: '0 10px',
                        fontWeight: 600,
                      }}
                    >
                      General
                    </div>
                  ),
                  children: (
                    <AbsenceTypesTab
                      data={accruing_conditions}
                      formik={formik}
                      isDetail
                    />
                  ),
                },
              ]}
            />
          </div>
        }
      />
    </div>
  );
};

export default AbsenceTypeDetail;
